import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {
  checkCoupleId,
  createCoupleData,
  createPatientRecordApi,
  dashboard,
  doctors_list,
  fetchPatientsRecords,
  fetchSpecificPatientData,
  loginapi,
  p_billArchive,
  p_billing,
  p_bills,
  p_reports,
  patientList,
  PatientsAppointment,
  patientsPrescription,
  recordAdd,
  reportDetailsApi,
  updatePatientApi,
  userCreateApi,
  usersListApi
} from '../../Context/apiData';
import {getSelectedBranch, normalizeBranch, withBranchParams, withBranchPayload} from '../../utils/branchUtils';

export const loginUser = createAsyncThunk('usersSlice/createUser', async userData => {
  try {
    const response = await axios.post(loginapi, userData);
    return response.data;
  } catch (error) {
    return error.message;
  }
});

export const getPatientsData = createAsyncThunk('usersSlice/getPatients', async payload => {
  try {
    const response = await axios.get(patientList, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      },
      params: withBranchParams(payload)
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});
export const createPatientsRecord = createAsyncThunk('usersSlice/createPatientsRecord', async userData => {
  try {
    const response = await axios.post(createPatientRecordApi, withBranchPayload(userData), {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    throw error.message;
  }
});

export const createCouplePatientsRecord = createAsyncThunk('usersSlice/createCouplePatientsRecord', async ({userData, patientId}) => {
  try {
    let response;
    if (patientId) {
      response = await axios.patch(createCoupleData + patientId + '/', withBranchPayload(userData), {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      });
    } else {
      response = await axios.post(createCoupleData, withBranchPayload(userData), {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      });
    }
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    throw error.message;
  }
});

export const getDashboardData = createAsyncThunk('usersSlice/getDashboardData', async payload => {
  try {
    const config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      params: withBranchParams(payload)
    };
    const response = await axios.get(dashboard, config);
    return response.data;
  } catch (error) {
    // if (error.response.data.status.code==401){
    //   window.location.href="/login"
    // }
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error;
  }
});

export const fetchSpecificPatient = createAsyncThunk('usersSlice/fetchSpecificPatient', async payload => {
  try {
    const response = await axios.get(fetchSpecificPatientData + payload + '/', {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

// export const updatePatient = createAsyncThunk(
//   "usersSlice/updatePatient",
//   async (userData, id) => {
//     console.log(userData, id, "----");
//     try {
//       const response = await axios.put(updatePatientApi + id + "/", userData, {
//         headers: {
//           Authorization: "Bearer " + localStorage.getItem("token"),
//         },
//       });
//       return response.data;
//     } catch (error) {
//       throw error.message;
//     }
//   }
// );

export const updatePatient = createAsyncThunk('usersSlice/updatePatient', async ({userData, id}) => {
  try {
    const response = await axios.put(updatePatientApi + id + '/', withBranchPayload(userData), {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    throw error.message;
  }
});

export const getPrescriptionHistory = createAsyncThunk('usersSlice/getPrescriptionHistory', async payload => {
  try {
    const response = await axios.get(patientsPrescription, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      },
      params: withBranchParams(payload)
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const getPatientsRecords = createAsyncThunk('usersSlice/getPatientsRecords', async payload => {
  try {
    const response = await axios.get(fetchPatientsRecords, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      },
      params: withBranchParams(payload)
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const fetchPatientsReports = createAsyncThunk('usersSlice/fetchPatientsReports', async payload => {
  try {
    const response = await axios.get(p_reports, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      },
      params: withBranchParams(payload)
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const getPatientBills = createAsyncThunk('usersSlice/getPatientBills', async payload => {
  try {
    const response = await axios.get(p_bills + payload + '/', {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const postPrescriptionTemplate = createAsyncThunk('usersSlice/postPrescriptionTemplate', async userData => {
  try {
    const response = await axios.post(patientsPrescription, withBranchPayload(userData.payload), {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    throw error.message;
  }
});

export const putPrescriptionTemplate = createAsyncThunk('usersSlice/putPrescriptionTemplate', async userData => {
  try {
    const response = await axios.put(patientsPrescription + userData.prescriptionId + '/', withBranchPayload(userData.payload), {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    throw error.message;
  }
});

export const updatePrescriptionTemplate = createAsyncThunk('usersSlice/updatePrescriptionTemplate', async ({userData, id}) => {
  try {
    const response = await axios.put(patientsPrescription + id + '/', withBranchPayload(userData), {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    throw error.message;
  }
});
export const getSpecificPrescriptionTemplate = createAsyncThunk('usersSlice/getSpecificPrescriptionTemplate', async id => {
  try {
    const response = await axios.get(patientsPrescription + id + '/', {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const postRecordsData = createAsyncThunk('usersSlice/postRecordsData', async userData => {
  try {
    const response = await axios.post(recordAdd, userData, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});
export const getPatientsReportDatas = createAsyncThunk('usersSlice/getPatientsReportDatas', async payload => {
  try {
    const response = await axios.get(p_reports, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      },
      params: withBranchParams(payload)
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});
export const getPatientsReportView = createAsyncThunk('usersSlice/getPatientsReportView', async payload => {
  try {
    const response = await axios.get(p_reports + payload + '/', {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const postPatientReport = createAsyncThunk('usersSlice/postPatientReport', async userData => {
  if (userData.type == '2') {
    try {
      const response = await axios.post(p_reports, withBranchPayload(userData.payload), {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      });
      return response.data;
    } catch (error) {
      if (error.response.data.status.code == 401) {
        //debugger
        localStorage.clear();
        window.location.href = '/login';
      }
      throw error.message;
    }
  } else {
    try {
      const response = await axios.post(patientsPrescription, withBranchPayload(userData.payload), {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      });
      return response.data;
    } catch (error) {
      if (error.response.data.status.code == 401) {
        //debugger
        localStorage.clear();
        window.location.href = '/login';
      }
      throw error.message;
    }
  }
});

export const updatePatientReport = createAsyncThunk('usersSlice/updatePatientReport', async userData => {
  try {
    const response = await axios.put(p_reports + userData.id + '/', withBranchPayload(userData.payload), {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    throw error.message;
  }
});

export const postPatientBill = createAsyncThunk('usersSlice/postPatientBill', async userData => {
  try {
    const response = await axios.post(p_billing, withBranchPayload(userData), {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    throw error;
  }
});

export const postPatientBillMsg = createAsyncThunk('usersSlice/postPatientBillMsg', async id => {
  try {
    console.log(id);
    const response = await axios.put(p_billing + id.id + '/', withBranchPayload(id.rme), {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log(error, 'this is guru');
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    throw error;
  }
});

// export const fetchPatientBill = createAsyncThunk(
//   "usersSlice/fetchPatientBill",
//   async (userData) => {
//     try {
//       const response = await axios.get(p_billing, userData, {
//         headers: {
//           Authorization: "Bearer " + localStorage.getItem("token"),
//         },
//       });
//       return response.data;
//     } catch (error) {
//       if (error.response.data.status.code == 401) {
//         console.log(error, "hehehehehhe");
//         console.log(error.data.status.code, "hehehehehhe");
//         //debugger
//         // localStorage.clear();
//         // window.location.href = "/login";
//       }
//       return error.message;
//     }
//   }
// );

export const fetchPatientBill = createAsyncThunk('usersSlice/fetchPatientBill', async payload => {
  try {
    const response = await axios.get(p_billing, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      },
      params: withBranchParams(payload)
    });

    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const fetchPatientsAppointment = createAsyncThunk('usersSlice/fetchPatientsAppointment', async payload => {
  try {
    const response = await axios.get(PatientsAppointment, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      },
      params: withBranchParams(payload)
    });

    return response.data;
  } catch (error) {
    if (error.response?.data?.status?.code == 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const postAppointment = createAsyncThunk('usersSlice/postAppointment', async payload => {
  try {
    const response = await axios.post(PatientsAppointment, withBranchPayload(payload), {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });

    return response.data;
  } catch (error) {
    if (error.response?.data?.status?.code == 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const getPatientAppointment = createAsyncThunk('usersSlice/getPatientAppointment', async payload => {
  try {
    const response = await axios.get(PatientsAppointment + payload, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });

    return response.data;
  } catch (error) {
    if (error.response?.data?.status?.code == 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const getDoctorsList = createAsyncThunk('usersSlice/getDoctorList', async payload => {
  try {
    const response = await axios.get(doctors_list, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });

    return response.data;
  } catch (error) {
    if (error.response?.data?.status?.code == 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const updatePatientAppointment = createAsyncThunk('usersSlice/updatePatientAppointment', async payload => {
  try {
    const response = await axios.put(PatientsAppointment + payload.editPatientID + '/', withBranchPayload(payload.appointmentData), {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });

    return response.data;
  } catch (error) {
    if (error.response?.data?.status?.code == 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const deletePatientAppointment = createAsyncThunk('usersSlice/deletePatientAppointment', async payload => {
  try {
    const response = await axios.delete(PatientsAppointment + payload + '/', {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
});

export const fetchUsersList = createAsyncThunk('usersSlice/fetchUsersList', async payload => {
  try {
    const response = await axios.get(
      usersListApi,
      {
        params: payload
      },
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') + ''
        }
      }
    );

    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const postCreateUser = createAsyncThunk('usersSlice/postCreateUser', async payload => {
  try {
    const response = await axios.post(userCreateApi, payload, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });

    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const getUserDetails = createAsyncThunk('usersSlice/getUserDetails', async payload => {
  try {
    const response = await axios.get(userCreateApi + payload, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });

    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const updateUserDetails = createAsyncThunk('usersSlice/updateUserDetails', async payload => {
  try {
    const response = await axios.put(userCreateApi + payload.editUserID + '/', payload.userData, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });

    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const deleteUserDetails = createAsyncThunk('usersSlice/deleteUserDetails', async payload => {
  try {
    const response = await axios.delete(userCreateApi + payload + '/', {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
});

export const deletePatientBill = createAsyncThunk('usersSlice/deletePatientBill', async payload => {
  try {
    const response = await axios.delete(p_billing + payload + '/', {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
});

export const getArchiveData = createAsyncThunk('usersSlice/getArchiveData', async payload => {
  try {
    const response = await axios.get(p_billArchive, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      },
      params: withBranchParams(payload)
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
});

export const getPatientsBillReportView = createAsyncThunk('usersSlice/getPatientsBillReportView', async payload => {
  try {
    const response = await axios.get(p_billing + payload + '/', {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});
export const fetchPatientDetailsUuid = createAsyncThunk('usersSlice/fetchPatientDetailsUuid', async payload => {
  try {
    const paramsPayload =
      payload && typeof payload === 'object' && !Array.isArray(payload)
        ? {...payload, skipBranchFilter: true}
        : {skipBranchFilter: true};
    const response = await axios.get(patientList, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      },
      params: withBranchParams(paramsPayload)
    });
    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const coupleIdChecker = createAsyncThunk('usersSlice/coupleIdChecker', async userData => {
  try {
    const response = await axios.post(checkCoupleId, userData.payload, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    });

    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    throw error.message;
  }
});

export const getReportDetails = createAsyncThunk('usersSlice/getReportDetails', async payload => {
  try {
    const response = await axios.get(reportDetailsApi, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      params: {
        date: payload
      }
    });
    return response;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const putReportDetails = createAsyncThunk('usersSlice/putReportDetails', async payload => {
  try {
    const response = await axios.put(reportDetailsApi + payload.id + '/', payload.value, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const postReportDetails = createAsyncThunk('usersSlice/postReportDetails', async payload => {
  try {
    const response = await axios.post(reportDetailsApi, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      //debugger
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});
